export const BUTTON_PRESS_THROTTLE_MS = 1_000;

export const shouldHandleButtonPress = (
  lastPressAt: number | null,
  currentPressAt: number,
  throttleTimeMs = BUTTON_PRESS_THROTTLE_MS
) => lastPressAt === null || currentPressAt - lastPressAt >= throttleTimeMs;

export const isPromiseLike = (value: unknown): value is PromiseLike<unknown> =>
  (typeof value === "object" || typeof value === "function") &&
  value !== null &&
  typeof (value as PromiseLike<unknown>).then === "function";

export const getButtonTextColor = (
  action?:
    | "primary"
    | "secondary"
    | "darker-secondary"
    | "positive"
    | "negative"
    | "default"
) => {
  switch (action) {
    case "primary":
      return "$white";
    case "secondary":
      return "$textLight0";
    case "darker-secondary":
      return "$secondary900";
    case "positive":
      return "$white";
    case "negative":
      return "$error600";
    case "default":
      return "$white";
    default:
      return "$white";
  }
};
